/*
 *
 * RootModal constants
 *
 */
export const SET_MODAL                  = 'src/RootModal/SET_MODAL';
export const CLEAR_MODAL                = 'src/RootModal/CLEAR_MODAL';
export const LAPSED_MODAL               = 'src/RootModal/LAPSED_MODAL';
export const COLOR_PICKER               = 'src/RootModal/COLOR_PICKER';
export const PLAN_SELECTION             = 'src/RootModal/PLAN_SELECTION';
export const INTUITIVE_MODAL            = 'src/RootModal/INTUITIVE_MODAL';
export const TOS_SELECTION_MODAL        = 'src/RootModal/TOS_SELECTION_MODAL';
export const UPGRADE_TO_ENTERPRISE_MODAL= 'src/RootModal/UPGRADE_TO_ENTERPRISE_MODAL';
export const RESUBSCRIBE_MODAL          = 'src/RootModal/RESUBSCRIBE_MODAL';
